import React, { useEffect, useState } from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import { ReactComponent as SvgDotPatternIcon } from "../../images/dot-pattern.svg";
import i18next, { t } from "i18next";
import DomainSearchInput from "./DomainSearchInput";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import logo from "../../images/tabebek-logo.png";
import i18n from "i18n";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const FormContainer = styled.div`
  ${tw`p-10 sm:p-12 md:p-16 bg-primary-500 text-gray-100 rounded-lg relative`}
  form {
    ${tw`mt-4`}
  }
  h2 {
    ${tw`text-3xl sm:text-4xl font-bold`}
  }
  input,
  textarea {
    ${tw`w-full bg-transparent text-gray-100 text-base font-medium tracking-wide border-b-2 py-2 text-gray-100 hocus:border-pink-400 focus:outline-none transition duration-200`};

    ::placeholder {
      ${tw`text-gray-500`}
    }
  }
`;

const TwoColumn = tw.div`flex flex-col sm:flex-row justify-between`;
const Column = tw.div`sm:w-5/12 flex flex-col`;
const InputContainer = tw.div`relative py-5 mt-6`;
const BtnContainer = tw.div`flex flex-row justify-end origin-center`;
const Label = tw.label`absolute top-0 left-0 tracking-wide font-semibold text-sm`;
const Input = tw.input``;
const TextArea = tw.textarea`h-24 sm:h-full resize-none`;
const SubmitButton = tw.button`w-full sm:w-32 py-3 bg-gray-100 text-primary-500 rounded-full font-bold tracking-wide shadow-lg uppercase text-sm transition duration-300 transform focus:outline-none focus:shadow-outline hover:bg-gray-300 hover:text-primary-700 hocus:-translate-y-px hocus:shadow-xl`;

const SvgDotPattern1 = tw(
  SvgDotPatternIcon
)`absolute bottom-0 right-0 transform translate-y-1/2 translate-x-1/2 -z-10 opacity-50 text-primary-500 fill-current w-24`;

const Header = tw.header`fixed z-20 top-0
 flex justify-center items-center
  w-full mx-auto bg-white h-24
`;
export const DesktopNavLinks = tw.nav`
  bg-white w-11/12 3xl:w-1/2 py-2 
`;
export const NavLink = tw.a`
text-lg my-2 lg:text-sm lg:mx-6 lg:my-0
font-semibold tracking-wide transition duration-300
pb-1 border-b-2 border-transparent 
`;
export const LogoLink = styled(NavLink)`
  ${tw`flex justify-between items-center font-black border-b-0 text-2xl! ml-0!`};
  img {
    ${tw`w-40`}
  }
`;

const LangButton = tw(
  PrimaryButtonBase
)`flex justify-center text-base w-24 h-8 p-0`;


export default () => {
  const isRTL = i18n.dir() === "rtl";
  const navigate = useNavigate();
  const [domainObj, setDomainObj] = useState(null);
  const [loading, setLoading] = useState(false);
  const [lang, setLang] = useState("العربية");
  console.log({ domainObj });

  const handleLang = () => {
    if (i18n.dir() === "rtl") {
      i18next.changeLanguage("en");
      setLang("العربية");
    } else {
      i18next.changeLanguage("ar");
      setLang("English");
    }
    document.body.dir = i18n.dir();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const {
      customer_name,
      customer_othname,
      customer_dmnname,
      customer_vatno,
      customer_email,
      customer_mobile,
      customer_address,
      customer_city,
      customer_district,
      customer_zipcode,
      packages_id,
    } = e.target;
    const url = `https://saas.tabebek.com/public/customerapiCreate`;
    console.log(
      // customer_name?.value,
      // customer_othname?.value,
      customer_dmnname?.value,
      "customer_dmnname"
      // customer_vatno?.value,
      // customer_email?.value,
      // customer_mobile?.value,
      // customer_address?.value,
      // customer_city?.value,
      // customer_district?.value,
      // customer_zipcode?.value,
      // packages_id?.value
    );

    if (domainObj?.data === 1) return toast.warn(domainObj?.message_en);

    const body = {
      customer_name: customer_name?.value || "",
      customer_othname: customer_othname?.value || "",
      customer_dmnname: customer_dmnname?.value || "",
      customer_vatno: customer_vatno?.value || "",
      customer_email: customer_email?.value || "",
      customer_mobile: customer_mobile?.value || "",
      customer_address: customer_address?.value || "",
      customer_city: customer_city?.value || "",
      customer_district: customer_district?.value || "",
      customer_zipcode: customer_zipcode?.value || "",
      packages_id: packages_id?.value || 1,
    };

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "*/*",
      },
      body: new URLSearchParams(body),
    };

    const submitPlan = async () => {
      try {
        const response = await fetch(url, requestOptions);
        const data = await response.json();
        console.log({ data });
        if (data?.success) {
          toast(data?.message_en);
          setLoading(false);
          // window.setTimeout(() => window.location.reload(), 2000);
          setDomainObj(null);
          navigate("/");
        } else {
          toast.warn(data?.message_en);
          setLoading(false);
          setDomainObj(null);
        }
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    };
    submitPlan();
    // if (
    //   branch?.value !== "" &&
    //   doctor?.value !== "" &&
    //   speciality?.value !== "" &&
    //   name?.value !== "" &&
    //   phone?.value !== "" &&
    //   date?.value !== "" &&
    //   time?.value !== ""
    // ) {
    //   setLoading(true);
    //   submitPlan();
    //   window.setTimeout(() => window.location.reload(), 2000);
    // } else {
    //   toast(t("fill_text"));
    // }
  };
  return (
    <>
      <Header className={"header-light"}>
        <DesktopNavLinks>
          <LogoLink href="#" tw="text-primary-100">
            <img src={logo} alt="logo" />
            <LangButton
              type="button"
              style={{
                alignItems: isRTL ? "center" : "normal",
              }}
              onClick={() => handleLang()}
            >
              {lang}
            </LangButton>
          </LogoLink>
        </DesktopNavLinks>
      </Header>
      <Container>
        <Content>
          <FormContainer>
            <div tw="mx-auto max-w-4xl">
              <h2>Organization Detail</h2>
              <form action="#" method="get" onSubmit={(e) => handleSubmit(e)}>
                <TwoColumn>
                  <Column>
                    <InputContainer>
                      <Label htmlFor="orgName">Name</Label>
                      <Input
                        id="orgName"
                        type="text"
                        name="customer_name"
                        placeholder=""
                      />
                    </InputContainer>
                    <InputContainer>
                      <Label htmlFor="otherName">Other Name</Label>
                      <Input
                        id="otherName"
                        type="text"
                        name="customer_othname"
                        placeholder=""
                      />
                    </InputContainer>
                  </Column>
                  <Column>
                    <InputContainer>
                      <DomainSearchInput
                        setDomainObj={setDomainObj}
                        onValidDomain={(selectedDomain) => {
                          console.log("Selected domain:", selectedDomain);
                          // Set to form field or state
                        }}
                      />

                      {/* <Label htmlFor="domainName">Domain Name</Label>
                    <Input
                      id="domainName"
                      type="text"
                      name="customer_dmnname"
                      placeholder=""
                    /> */}
                    </InputContainer>
                    <InputContainer>
                      <Label htmlFor="email">Email</Label>
                      <Input
                        id="email"
                        type="email"
                        name="customer_email"
                        placeholder="E.g. john@mail.com"
                      />
                    </InputContainer>
                  </Column>
                </TwoColumn>
                <TwoColumn>
                  <Column>
                    <InputContainer>
                      <Label htmlFor="vat">VAT</Label>
                      <Input
                        id="vat"
                        type="text"
                        name="customer_vatno"
                        placeholder="E.g. VAT123456"
                      />
                    </InputContainer>
                    <InputContainer>
                      <Label htmlFor="mobile">Mobile Number</Label>
                      <Input
                        id="mobile"
                        type="text"
                        name="customer_mobile"
                        placeholder="E.g. +966123456789"
                      />
                    </InputContainer>
                  </Column>
                  <Column>
                    <InputContainer>
                      <Label htmlFor="city">City</Label>
                      <Input
                        id="city"
                        type="text"
                        name="customer_city"
                        placeholder="E.g. Riyadh"
                      />
                    </InputContainer>
                    <InputContainer>
                      <Label htmlFor="district">District</Label>
                      <Input
                        id="district"
                        type="text"
                        name="customer_district"
                        placeholder="E.g. Olaya"
                      />
                    </InputContainer>
                  </Column>
                </TwoColumn>
                <TwoColumn>
                  <Column>
                    <InputContainer>
                      <Label htmlFor="zip">Zip Code</Label>
                      <Input
                        id="zip"
                        type="text"
                        name="customer_zipcode"
                        placeholder="E.g. 11564"
                      />
                    </InputContainer>
                  </Column>
                </TwoColumn>
                <InputContainer tw="flex-1">
                  <Label htmlFor="address">Address</Label>
                  <TextArea
                    id="address"
                    name="customer_address"
                    placeholder="E.g. Details about your event"
                  />
                </InputContainer>
                <BtnContainer>
                  <SubmitButton type="submit" value="Submit">
                    {loading ? "Submiting..." : t("Submit")}
                  </SubmitButton>
                </BtnContainer>
              </form>
            </div>
            <SvgDotPattern1 />
          </FormContainer>
        </Content>
      </Container>
    </>
  );
};
